// A location that opens in the visitor's maps app. Google's universal search
// URL works on every platform: it opens the Google Maps app on phones that have
// it, and maps in the browser everywhere else.
export function mapsUrl(...parts) {
  const query = parts.filter(Boolean).join(', ');
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

export default function MapLink({ query, className = '', children }) {
  const q = Array.isArray(query) ? query : [query];
  if (!q.some(Boolean)) return children;
  return (
    <a
      href={mapsUrl(...q)}
      target="_blank"
      rel="noopener noreferrer"
      title="Open in Maps"
      className={`text-brand-dark font-medium underline decoration-brand/60 underline-offset-2 hover:text-brand hover:decoration-brand transition-colors ${className}`}
    >
      {children}
    </a>
  );
}
